module.exports = __webpack_public_path__ + "static/media/ic_userGuide_sacit.cd99f3f7.png";